import React, { Fragment } from 'react';
import Field from '../../components/Field';

const Kjosandi = props => {
  const { kjosandi, activeKosning, timestamp } = props;

  return (
    <div style={{ marginTop: 40 }}>
      <Field isBox label="Fullt nafn kjósanda samkvæmt Þjóðskrá" name="kjs-nafn" id="kjs-nafn" style={{ flex: 1 }} value={kjosandi.nafn} />
      <div style={{ gap: 10, display: "flex", marginTop: 30, marginBottom: 50 }}>
        <Field isBox label="Kennitala" id="kt-f" style={{ flex: 1 }} value={kjosandi.kennitala} />
        <Field isBox label="Lögheimili" id="log-f" style={{ flex: 1 }} value={kjosandi.husheiti} />
        <Field isBox label="Sveitarfélag" id="svf-f" style={{ flex: 1 }} value={kjosandi.sveitarfelag} />
      </div>
      <p style={{ marginBottom: 40, maxWidth: 500 }}>
        Ég lýsi því yfir að ég hef án aðstoðar og án þess að nokkur annar hafi séð, greitt atkvæði, sett það í umslag og límt umslagið aftur:
      </p>

      <div style={{ gap: 30, display: "flex", marginBottom: 30 }}>
        <Field label="Staður" style={{ flex: 3 }} id="stad-f" />
        <Field label="Dagsetning" style={{flex: 2 }} id="dags-f" value={timestamp} />
      </div>

    <div style={{ gap: 30, display: "flex", marginBottom: 30 }}>
      <Field label="Undirritun kjósanda" style={{ flex: 3 }} sub="(Fái kjósandi aðstoð skal ekki undirritað)" />
      <div style={{ flex: 2 }}></div>
    </div>
    <hr />

      {/* <SplitPane
        leftContent={<TegundKosningar activeKosning={activeKosning} />}
        leftWidth={"34%"}
        rightContent={<UndirskriftKjosanda />}
        rightWidth={"70%"}
      /> */}
    </div>
  );
}

export default Kjosandi;